module.exports = __webpack_public_path__ + "static/media/mouthRight.68929725.obj";